<script>
import Swiper from "swiper";
import * as fancybox from '@fancyapps/ui';
const { Fancybox } = fancybox;
import "@fancyapps/ui/dist/fancybox.css";

export default {
  components: { Fancybox },
  props: {
    photos: { type: Array, default: () => [] },
    participants: { type: Array, default: () => [] },
  },
  data() {
    return {
      swiper: null,
    };
  },
  computed: {
    isSlider() {
      return true;
    },
  },
  mounted() {
    this.swiper = new Swiper(this.$refs.swiper, {
      slidesPerView: 4,
      speed: 400,
      slidesPerColumnFill: "row",
      spaceBetween: 28,
      initialSlide: 0,
      autoplay: true,
      delay: 1000,
      loop: false,
      breakpoints: {
        320: {
          slidesPerView: 2,
          // @ts-expect-error wrong types in swiper library
          slidesPerColumn: 2,
          spaceBetween: 18,
        },
        640: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
        1280: {
          slidesPerView: 4,
        },
      },
    });

    Fancybox.bind("[data-fancybox='gallery']", {
      Image: {
        zoom: false,
        wheel: "slide",
        hideScrollbar: false,
      },
    });
  },
};
</script>

<template>
  <div class="w-full" v-if="isSlider">
    <div class="relative swiper-container" ref="swiper">
      <div class="swiper-wrapper">
        <div v-for="(photo, index) in photos" :key="photo.fileKey" class="swiper-slide max-h-50">
          <img data-fancybox="gallery" :href="`https://ucarecdn.com/${photo.fileKey}/img.png`"
            :data-caption="participants[index]" class="rounded-lg object-cover w-full h-full cursor-pointer text-xl"
            :src="`https://ucarecdn.com/${photo.fileKey}/-/format/auto/-/quality/smart/image.png`" />
        </div>
      </div>
    </div>

    <div class="
        slide-next
        absolute
        -left-12
        top-28
        z-10
        cursor-pointer
        hidden
        xl:block
      " 
      v-if="photos.length > 4" @click="swiper.slidePrev()">
      <img loading="lazy" src="/arrow-l.svg" alt />
    </div>
    <div loading="lazy" class="
        slide-next
        absolute
        -right-12
        top-28
        transform
        rotate-180
        z-10
        cursor-pointer
        hidden
        xl:block
      "
       v-if="photos.length > 4" @click="swiper.slideNext()">
      <img src="/arrow-l.svg" alt />
    </div>
  </div>
</template>
